/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaveRequestBody
 */
export interface LeaveRequestBody {
    /**
     * 退会時に入力するパスワード
     * @type {string}
     * @memberof LeaveRequestBody
     */
    password: string;
}

export function LeaveRequestBodyFromJSON(json: any): LeaveRequestBody {
    return LeaveRequestBodyFromJSONTyped(json, false);
}

export function LeaveRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaveRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': json['password'],
    };
}

export function LeaveRequestBodyToJSON(value?: LeaveRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
    };
}

